const appLanguageToMUILanguageTokenMap = {
  en: 'enUS',
  ru: 'ruRU',
  es: 'esES',
} as const;

type SupportedLanguage = keyof typeof appLanguageToMUILanguageTokenMap;
type TableLanguage = (typeof appLanguageToMUILanguageTokenMap)[SupportedLanguage];

export function transformAppLanguageToTableLanguageToken(language: string): TableLanguage {
  if (language in appLanguageToMUILanguageTokenMap) {
    return appLanguageToMUILanguageTokenMap[language as SupportedLanguage];
  }

  return appLanguageToMUILanguageTokenMap.en;
}
